import type { Tab } from "types/tabs.types"
import { ALL_ALERTS_SEARCH_PARAMS } from "./constants"

export const getSentriPowerlineTabsConfig = (
  search: string,
  hasAmbientTab = false,
): Tab[] => {
  const tabs: Omit<Tab, "value">[] = [
    { labelKey: "tabs.SPAN", to: { pathname: "", search } },
    { labelKey: "tabs.DEVICE", to: { pathname: "device-data", search } },
    ...(hasAmbientTab
      ? [{ labelKey: "tabs.AMBIENT", to: { pathname: "ambient", search } }]
      : []),
    {
      labelKey: "tabs.ALERTS",
      to: { pathname: "alerts", search: ALL_ALERTS_SEARCH_PARAMS },
    },
    { labelKey: "tabs.SETTINGS", to: { pathname: "settings" } },
  ]

  return tabs.map((tab, index) => ({ ...tab, value: index }))
}

export const getOtherDeviceTypesTabsConfig = (search: string): Tab[] => [
  {
    labelKey: "tabs.OVERVIEW",
    value: 0,
    to: { pathname: "", search },
  },
  {
    labelKey: "tabs.ALERTS",
    value: 1,
    to: { pathname: "alerts", search: ALL_ALERTS_SEARCH_PARAMS },
  },
  {
    labelKey: "tabs.SETTINGS",
    value: 2,
    to: { pathname: "settings" },
  },
]

export const getWeatherStationTabsConfig = (search: string): Tab[] => [
  {
    labelKey: "tabs.AMBIENT",
    value: 0,
    to: { pathname: "", search },
  },
  {
    labelKey: "tabs.DEVICE",
    value: 1,
    to: { pathname: "device-data", search },
  },
  {
    labelKey: "tabs.ALERTS",
    value: 2,
    to: { pathname: "alerts", search: ALL_ALERTS_SEARCH_PARAMS },
  },
  {
    labelKey: "tabs.SETTINGS",
    value: 3,
    to: { pathname: "settings" },
  },
]

export const getVirtualPowerlineTabsConfig = (_search: string): Tab[] => [
  {
    labelKey: "tabs.ALERTS",
    value: 0,
    to: { pathname: "", search: ALL_ALERTS_SEARCH_PARAMS },
  },
  {
    labelKey: "tabs.SETTINGS",
    value: 1,
    to: { pathname: "settings" },
  },
]

export const getSentriTowerTabsConfig = (
  search: string,
  hasAmbientTab: boolean,
): Tab[] => {
  const tabs: Omit<Tab, "value">[] = [
    { labelKey: "tabs.TOWER_HEALTH", to: { pathname: "", search } },
    { labelKey: "tabs.DEVICE", to: { pathname: "device-data", search } },
    ...(hasAmbientTab
      ? [{ labelKey: "tabs.AMBIENT", to: { pathname: "ambient", search } }]
      : []),
    {
      labelKey: "tabs.ALERTS",
      to: { pathname: "alerts", search: ALL_ALERTS_SEARCH_PARAMS },
    },
    { labelKey: "tabs.SETTINGS", to: { pathname: "settings" } },
  ]

  return tabs.map((tab, index) => ({ ...tab, value: index }))
}
